import type { CleaningTaskQueueResponse } from '@/shared/api';

/**
 * Was ohne Arbeitsdetails bleibt: der Server liefert für fremde oder noch freie Aufgaben nur die
 * Zusammenfassung (`canViewDetails`). Der Satz sagt, warum Räume und Notiz fehlen.
 */
export function ForeignTaskNotice({ task }: { task: CleaningTaskQueueResponse }) {
  const owner = task.assignedToUserName;
  const banner = task.canClaim
    ? 'Diese Aufgabe ist frei. Räume, Notiz und Meldungen siehst du, sobald du sie übernimmst.'
    : owner
      ? `Diese Aufgabe gehört ${owner}. Du kannst sie lesen, aber nicht bearbeiten.`
      : 'Du kannst diese Aufgabe lesen, aber nicht bearbeiten.';
  return (
    <>
      <p
        role="status"
        className="bg-forest-soft text-forest-deep rounded-tile p-3 text-[13px] font-semibold"
      >
        {banner}
      </p>
      {task.canClaim ? (
        task.photoSlotCount > 0 && (
          <p className="border-hairline rounded-tile border bg-white p-3.5 text-[13px]">
            <b>{task.photoSlotCount} Fotos verlangt</b> – je Raum eines; mit dem letzten ist die
            Aufgabe erledigt.
          </p>
        )
      ) : (
        <section className="border-hairline rounded-tile flex flex-col gap-1.5 border bg-white p-3.5">
          <b className="text-[15px]">
            {task.photoSlotCount > 0
              ? `${task.filledPhotoSlotCount} von ${task.photoSlotCount} Fotos`
              : 'ohne Fotos'}
          </b>
          <span className="text-ink-soft text-[13px] leading-relaxed">
            Räume, Notiz und Meldungen sehen nur {owner ?? 'die zuständige Person'} und die Leitung
            – so liefert es der Server.
          </span>
        </section>
      )}
    </>
  );
}
